
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
dateStatus:false,
dateStatus1:false,
searchPop:false,
loadmoreText:'正在加载。。。',
busy:false,
endDate:'',
startDate:'',
endDate1:'',
startDate1:'',
outIndex:0,
wash_code:'',
name:'',
phone:'',
index:0,
index1:0,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
outDays:[




{
key:4,
text:'四天以上'
},
{
key:5,
text:'五天以上'
},
{
key:8,
text:'八天以上'
},
{
key:10,
text:'十天以上'
},
],
}
},
created(){
this.startDate = '';
this.endDate = '';
this.name = '';
this.phone = '';
this.config();

},
amount(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.name = '';
this.phone = '';
this.wash_code = '';
this.startDate = '';
this.startDate1 = '';
this.endDate = '';
this.endDate1 = '';
this.outIndex = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
this.searchPop = false;
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
this.searchPop = false;
},
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);
nowDate.setMonth(nowDate.getMonth());
var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
setDate1() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);
nowDate.setMonth(nowDate.getMonth());
var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
showDate1(e){
this.index1 = e;
this.dateStatus1 = true;
},
dateChange1(e){
if(this.index1 > 0){
this.endDate1 = e;
}else{
this.startDate1 = e;
}
},
outTime(index){
this.outIndex = this.outIndex === index ? '' : index;
},
getList(){
let outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
this.$api.washCode({last_id:this.lastId,page_flag:this.pageFlag,wash_code:this.wash_code,outDay:outDay,type:2,start:this.startDate,end:this.endDate,start1:this.startDate1,end1:this.endDate1,name:this.name,phone:this.phone}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.wash_code = res.resultStr.split(',')[1];
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/timeOutClotheWash.vue